export const BLOG_API = 'https://y32k94fh1c.execute-api.us-west-2.amazonaws.com/default/BlogPostHandler';
export const publishedPosts = data => {
  const posts = Array.isArray(data) ? data : data?.posts;
  if (!Array.isArray(posts)) throw new Error('Unable to load blog posts.');
  return posts.filter(post => post?.isPublished === true || post?.public === true);
};
export async function fetchPublicPosts(host, signal) {
  const response = await fetch(`${BLOG_API}?host=${encodeURIComponent(host)}`, { signal });
  if (!response.ok) throw new Error('Unable to load blog posts.');
  return publishedPosts(await response.json());
}
